// extracted by mini-css-extract-plugin
module.exports = {"container":"Editor_container__JqLRe","dropzone":"Editor_dropzone__UFdUZ","fileUpload":"Editor_fileUpload__2A4xF","text":"Editor_text__wFQcg","slider":"Editor_slider__2p1Q3"};